import { render, staticRenderFns } from "./TeacherMainteTab.vue?vue&type=template&id=2e3873e9&scoped=true&"
import script from "./TeacherMainteTab.vue?vue&type=script&lang=ts&"
export * from "./TeacherMainteTab.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherMainteTab.vue?vue&type=style&index=0&id=2e3873e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3873e9",
  null
  
)

export default component.exports